import {
  FETCH_UNREAD_CHATS_REQUEST,
  FETCH_UNREAD_CHATS_SUCCESS,
  FETCH_UNREAD_CHATS_FAILURE
} from '../../actions/inbox/conversationActions';
import {
  ADD_UNREAD_CHAT,
  REMOVE_UNREAD_CHAT,
  SET_PLATFORM_COUNTS,
  UPDATE_PLATFORM_COUNT
} from '../../actions/inbox/unreadChatsActions';

const initialState = {
  loading: false,
  data: null,
  platformCounts: null,
  error: null
};

export default function unreadChatsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_UNREAD_CHATS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_UNREAD_CHATS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.unreadChats,
        error: null
      };
    case FETCH_UNREAD_CHATS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case SET_PLATFORM_COUNTS:
      return {
        ...state,
        platformCounts: action.payload
      };
    case UPDATE_PLATFORM_COUNT:
      return {
        ...state,
        platformCounts: action.payload
      };
    case ADD_UNREAD_CHAT:
    case REMOVE_UNREAD_CHAT:
      return {
        ...state,
        data: action.payload.data
      };
    default:
      return state;
  }
}
